<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {getCookie, getSelectedCity} from "../../utils";
    import Snackbar, {Label} from "@smui/snackbar";
    import {Actions} from "@smui/dialog";
    import IconButton from "@smui/icon-button";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    const dispatch = createEventDispatcher();

    export let params: any;
    export let loading: boolean = false;
    export let showCancel: boolean = true;
    export let enableByVehicle = true;

    let buscarPor: string = 'placa';
    export let title: string = 'Selecciona tu método de validación';
    let placa: string;
    let marca: any;
    let linea: any;
    let order: string;
    let manager: ManagerVehicles;
    let snackbar = {
        cmpt: null,
        message: ''
    }
    export let selectedLine: any;

    let lineas = [];

    onMount(() => {
        manager = ManagerVehicles.getInstance();
    });

    async function send() {
        if (placa) {
            loading = true;
            await manager.searchByPlaca(placa);
            loading = false;
            dispatch('close');
        }
    }

    function setMarca() {
        lineas = params.lineas.filter(l => l.marca_slug === marca);
        selectedLine = null;
    }

    function saveVehicle() {
        const {
            cod_modelo_tasa,
            label,
            marca_slug,
            value
        } = selectedLine;
        const selectedBrand = params.marcas.find(m => m.value === marca);
        manager.addVehicle({
            brands: [{
                label: selectedBrand?.label || '',
                name: selectedBrand?.label || '',
                slug: marca_slug,
                lineas: [
                    {
                        label,
                        name: label,
                        slug: value
                    }
                ]
            }],
            cilindraje: null,
            codMarca: null,
            codModelo: null,
            codModeloTASA: cod_modelo_tasa,
            descMarca: 'NISSAN',
            descModelo: label,
            descModeloTASA: selectedBrand?.label || '',
            placa: null,
            tipoCombustible: '',
            vin: null,
            year: null,
        }, true);
        dispatch('close');
    }

    function searchOrder() {
        const url = new URL('/backend/servicio/datos-vehiculo/', location.origin);
        url.search = new URLSearchParams({
            codCia: `1`,
            codUN: `10`,
            ciudad: getSelectedCity(),
            pedido: order,
        }).toString();
        loading = true;
        fetch(url.toString(), {
            method: 'GET',
            headers: {
                'X-CSRFToken': getCookie('csrftoken')
            }
        }).then((response) => {
            if (response.ok) {
                response.json().then((vehicle) => {
                  manager.addVehicle(vehicle, true, true);
                  loading = false;
                  dispatch('close');
                }).catch(() => {
                    snackbar.message = 'Se ha presentado un error consultando el pedido';
                    snackbar.cmpt.open();
                    loading = false;
                });
            } else {
                snackbar.message = 'Se ha presentado un error consultando el pedido';
                snackbar.cmpt.open();
                loading = false;
            }
        }).catch(() => {
            snackbar.message = 'Se ha presentado un error consultando el pedido';
            snackbar.cmpt.open();
            loading = false;
        });
    }
</script>
<div class="mt-3">
    <strong class="block mb-15" style="font-size: 14px; color: var(--text-gray)">
        {title}
    </strong>
    <div class="mb-1">
        <div class="naui-field" class:mb-ii={buscarPor==='vehiculo'}>
            <select class="naui-input" bind:value={buscarPor}>
                <option value="placa">Busca por placa</option>
                {#if enableByVehicle}
                    <option value="vehiculo">Busca por vehículo</option>
                {/if}
                <option value="pedido">Busca por número de pedido</option>
            </select>
        </div>
        {#if buscarPor === 'vehiculo'}
            <small class="block mb-15" style="color: black">Si estás en un proceso de compra de vehículo actualmente
                ingresa por número de orden</small>
        {/if}
    </div>
    {#if buscarPor === 'placa'}
        <div class="naui-field mb-1">
            <input class="naui-input"
                   type="text"
                   bind:value={placa}
                   placeholder="Ingresa la placa de tu NISSAN">
        </div>
    {:else if buscarPor === 'vehiculo'}
        <div class="naui-field mb-1">
            <select class="naui-input" bind:value={marca} on:change={setMarca}>
                <option selected hidden>Selecciona el modelo</option>
                {#each params.marcas as marca}
                    <option value={marca.value}>{marca.label}</option>
                {/each}
            </select>
            <span></span>
        </div>
        <div class="naui-field mb-1">
            <select class="naui-input" bind:value={selectedLine}>
                <option hidden value={null}>Selecciona una línea</option>
                {#each lineas as linea}
                    <option value={linea}>{linea.label}</option>
                {/each}
            </select>
            <span></span>
        </div>
    {:else if buscarPor === 'pedido'}
        <div class="naui-field mb-1">
            <input class="naui-input"
                   type="text"
                   placeholder="Ingresa el número del pedido"
                   bind:value={order}>
        </div>
    {/if}

    <div class="box mt-2">
        {#if loading}
            <div class="text-c">
                Consultando...
            </div>
        {:else}
            {#if buscarPor === 'placa'}
                <button type="submit"
                        class="btn accent min-w-200px text-c"
                        on:click={()=>send()}>
                    BUSCAR
                </button>
            {:else if buscarPor === 'vehiculo'}
                <button type="submit"
                        class:disabled="{!selectedLine}"
                        on:click={()=>saveVehicle()}
                        class="btn accent min-w-200px text-c disabled">
                    SELECCIONAR
                </button>
            {:else if buscarPor === 'pedido'}
                <button type="submit"
                        class:disabled="{!order}"
                        on:click={()=>searchOrder()}
                        class="btn accent min-w-200px text-c disabled">
                    BUSCAR PEDIDO
                </button>
            {/if}
        {/if}
    </div>
    {#if showCancel}
        <div class="box-r mt-15">
            <div class="view-more"
                 on:click={()=>dispatch('cancel')}>
                Cancelar
            </div>
        </div>
    {/if}
</div>


<Snackbar bind:this={snackbar.cmpt}>
    <Label>{snackbar.message}</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbar.cmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>